export const firebaseConfig = {
    apiKey: "AIzaSyASFmKPaxbvR0erbeAANRnkRi5jZqA-ygE",
    authDomain: "chats-f2480.firebaseapp.com",
    projectId: "chats-f2480",
    storageBucket: "chats-f2480.appspot.com",
    messagingSenderId: "359718162137",
    appId: "1:359718162137:web:03153331f230b4bae2f8c8"
  };